const isLowResolution = (): boolean => {
  return window.matchMedia(`(max-width: 768px)`).matches;
};

export default {
  isLowResolution,
};
